import { render } from "./LegacyGroupExcursionReport.vue?vue&type=template&id=18f5b046"
import script from "./LegacyGroupExcursionReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupExcursionReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__